import memoizeOne from 'memoize-one';
import { buildCustomerAndDatasourceLicensesKey, buildCustomerLicensesKey } from '~/CustomerDatasourceLicence';

const resolveIsLicensed = memoizeOne((accessToken, customerDatasourceLicences, sourceType) => {
	if (accessToken === null) {
		return null;
	}

	const customerId = accessToken.user.customer.id;
	const licenses = customerDatasourceLicences.getIn(buildCustomerLicensesKey(customerId), null);

	if (licenses === null || licenses.isFetching) {
		return null;
	}

	return customerDatasourceLicences.getIn(buildCustomerAndDatasourceLicensesKey(customerId, sourceType), null) !== null;
});

export default resolveIsLicensed;
